import { type ComponentProps, type ComponentType, type ReactNode } from 'react';

import { type CardMiniGameType } from '@/common/types/dice-game/index.ts';

import { cardsMap, type CardsMapType } from './config.ts';

interface CardSelectorProps<T extends CardMiniGameType> {
  kind: T;
  props: ComponentProps<CardsMapType[T]>;
}

const CardSelector = <T extends CardMiniGameType>({
  kind,
  props,
}: CardSelectorProps<T>): ReactNode | JSX.Element | null => {
  const Component = cardsMap[kind] as ComponentType<
    ComponentProps<CardsMapType[T]>
  >;

  return Component ? <Component {...props} /> : null;
};

export { CardSelector };
